import React from 'react';
import './WaveIcon.scss';

interface Props {
	animated?: boolean;
	size: number;
}

export const WaveIcon: React.FC<Props> = props => (
	<svg
		className={props.animated ? 'wave-icon animated' : 'wave-icon'}
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>wave</title>
		<path d='M13.24,23.66A9.18,9.18,0,0,1,9.87,23c-3.46-1.36-6.4-4.83-4.67-9.2L7.74,7.34A2,2,0,0,1,8.9,6.14a2.07,2.07,0,0,1,1.49,0,2,2,0,0,1,1.1,1,2,2,0,0,1,0,1.67l-1.29,3.28c.52.72,2.06,3.17.91,5.58a.44.44,0,0,1-.58.21.44.44,0,0,1-.21-.58c1.1-2.31-.93-4.84-.95-4.87l-.16-.2,1.47-3.73A1.12,1.12,0,0,0,10.07,7a1.12,1.12,0,0,0-1.52.69L6,14.11C4.5,17.94,7.12,21,10.19,22.19s7.06.77,8.56-3.06l3.4-8.63a1.38,1.38,0,0,0-.44-1.84A1.07,1.07,0,0,0,20.3,9a.43.43,0,0,1-.61.08.44.44,0,0,1-.08-.61,1.94,1.94,0,0,1,2.53-.57A2.23,2.23,0,0,1,23,10.82l-3.4,8.63a6.29,6.29,0,0,1-4.16,3.9A7.42,7.42,0,0,1,13.24,23.66Z' />
		<path d='M17.67,15a.41.41,0,0,1-.16,0,.44.44,0,0,1-.25-.57l3.18-8.06a.93.93,0,0,0-.38-1.25,1.36,1.36,0,0,0-1.71.26.44.44,0,0,1-.62.05.43.43,0,0,1-.05-.61,2.23,2.23,0,0,1,2.82-.45,1.81,1.81,0,0,1,.75,2.32l-3.18,8.06A.44.44,0,0,1,17.67,15Z' />
		<path d='M15.38,12.2a.41.41,0,0,1-.16,0,.43.43,0,0,1-.25-.56l3.15-8a1.09,1.09,0,0,0-.63-1.51,1.1,1.1,0,0,0-1.5.68l-3,7.49L12.23,10c.23-.58,2.12-5.39,2.17-5.53A1.07,1.07,0,0,0,13.69,3a1.07,1.07,0,0,0-1.45.66L11,6.9a.43.43,0,0,1-.81-.31l1.27-3.22A2,2,0,0,1,14,2.21,2.07,2.07,0,0,1,15,3l.2-.5a2,2,0,0,1,2.63-1.17,2,2,0,0,1,1.12,2.64l-3.15,8A.43.43,0,0,1,15.38,12.2Z' />
		<path d='M4.08,11H4a.43.43,0,0,1-.39-.48C4,6.88,5.59,4.37,8.52,2.86A.43.43,0,0,1,9.1,3a.44.44,0,0,1-.18.59C6.27,5,4.83,7.28,4.51,10.61A.43.43,0,0,1,4.08,11Z' />
		<path d='M1.26,11.33H1.2a.42.42,0,0,1-.37-.49C1.54,5.62,3.78,2.1,7.48.38a.45.45,0,0,1,.58.21.44.44,0,0,1-.22.58C4.43,2.76,2.36,6.05,1.69,11A.44.44,0,0,1,1.26,11.33Z' />
	</svg>
);
